export default __webpack_public_path__ + "static/media/home_coffee.a5118ad5.png";